"use client";

import { UserButton } from "@/lib/auth-shim/client";
import { BillingPanel } from "@/components/BillingPanel";

export function CustomUserButton() {
    return (
        <UserButton
            appearance={{
                elements: {
                    avatarBox: "clerk-avatar",
                },
            }}
        >
            <UserButton.UserProfilePage
                label="Billing"
                url="subscription"
                labelIcon={
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
                        <rect x="2" y="5" width="20" height="14" rx="2" />
                        <path d="M2 10h20" />
                        <path d="M6 15h4" />
                    </svg>
                }
            >
                <div className="bill-page">
                    <header className="bill-page__header">
                        <h1 className="bill-page__title">Billing</h1>
                        <p className="bill-page__subtitle">
                            Your plan, practice usage, and payment history.
                        </p>
                    </header>
                    <BillingPanel />
                </div>
            </UserButton.UserProfilePage>

            <UserButton.MenuItems>
                <UserButton.Link
                    href="/progress"
                    label="Your Progress"
                    labelIcon={
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                        </svg>
                    }
                />
                <UserButton.Link
                    href="/plans"
                    label="Plans & Pricing"
                    labelIcon={
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
                            <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
                        </svg>
                    }
                />
                <UserButton.Action label="manageAccount" />
            </UserButton.MenuItems>
        </UserButton>
    );
}
